<div class="container-fluid">
  <div class="row">
    <div class="col-md-2 col-lg-3"></div>
    <div class="col-md-8 col-lg-6">
      @if (isLoaded) {
        <div class="card mb-3" [@fadeInAnimation]>
          <div class="card-header">
            <fa-icon [icon]="['fas', 'sign-in-alt']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.mina-inloggningar' | translate }}
          </div>
          <div class="card-body">
            <p class="h5">{{ 'label.valj-instans' | translate }}</p>
            @for (i of instances; track i) {
              <button class="btn-garanti btn-pink w-100" [class.active]="i.id===lastInstanceId && i.roleType===lastRoleType" (click)="setInstance(i)">
                @if (i.roleType !== 'arb') {
                  Som {{ i.roleName.toLowerCase() }} i {{ i.name }}
                }
                @if (i.roleType === 'arb') {
                  {{ i.debtorName }} @if (i.caseType) {
                  <span>({{ i.caseType }})</span>
                }
              }
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
</div>
